import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

@Component({
    selector: "app-eff-textarea-field",
    templateUrl: "./eff-textarea-field.component.html",
    styleUrls: ["./eff-textarea-field.component.scss"],
    imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule]
})
export class EffTextareaFieldComponent implements OnInit, OnChanges {
    @Input() label: string;
    @Input() model;
    @Input() uiid: string = "undefined";
    @Input() bordered: boolean = true;
    @Input() disabled: boolean = false;
    @Input() formController: FormControl = new FormControl();

    @Output() modelChange = new EventEmitter();

    textareaUiid: string = "eff-textarea";

    ngOnInit() {
        if (this.model) {
            this.formController.setValue(this.model);
        }

        if (this.disabled) {
            this.disableEnableFormControl();
        }
        if (this.uiid) {
            this.textareaUiid += `-${this.uiid}`;
        }
    }

    onModelChanged() {
        this.modelChange.emit(this.formController.value);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["model"]) {
            this.formController.setValue(this.model);
        }

        if (changes["disabled"]) {
            this.disableEnableFormControl();
        }
    }

    disableEnableFormControl() {
        if (this.formController) {
            if (this.disabled) {
                this.formController.disable();
            } else {
                this.formController.enable();
            }
        }
    }
}
